import React, {useState} from 'react';
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {ReactComponent as CourseIcon} from '../../../assets/main/groups/main-top/course.svg';
import {CourseContainer} from "./cours-container/course-container";
import {CourseFilter} from "components/pages/buy-couse/cours-filter/CourseFilter";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";

export const BuyCourse = () => {
    const [valueCourse, setValueCourse ] = useState('BYN')
    const handlePaymentChange = (value: string) => {
        setValueCourse(value);
    };

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Курсы'} tabs={false} setting={false} link={'/buy-course'} icons={<CourseIcon/>}/>
                <CourseFilter onPaymentChange={handlePaymentChange} />
                <CourseContainer valueCourse={valueCourse} />
            </div>
        </AuthWrapper>
    );
};

